/* eslint-disable */


function init() {
  var accordions = $('.accordion');
  var expandClass = 'accordion-item-expanded';

  if (!accordions.length) return;
  $.each(accordions, function(i, accordion) {
    var toggles = $(accordion).find('.accordion-toggle');
    var items = $(accordion).find('.accordion-item');
    toggles.click(function(e) {
      e.preventDefault();
      var item = $(this).parent('.accordion-item');
      if (item.hasClass(expandClass)) {
        item.removeClass(expandClass);
      } else {
        items.removeClass(expandClass);
        item.addClass(expandClass);
      }
    });
  });
}

module.exports = {
  initialise: init
};
